// farehabor lightframe api 
let lang = document.documentElement.lang || 'nl-NL';

$('[data-fareharbor-open]').on('click', function() {
    let postID = $(this).data('fareharbor-open'),
        $button = $(this),
        $buttonLoader = $button.find('.btn__loader');

    $button.prop('disabled', true);
    if ($buttonLoader.length > 0) {
        $buttonLoader.show();
    }
    
    // ajax request
    $.ajax({
        type: 'GET',
        url: resturl + 'fareharbor/get-parameters',
        data: {
            id: postID
        }
    }).done(function(data) {
        // open widget
        let flow = data.flow, 
            item = data.item,
            shortname = data.shortname,
            ref = data.ref;

        openWidget(flow, item, shortname, ref);
    }).always(function() {
        // console.log('loading...');

        if ($buttonLoader.length > 0) {
            $buttonLoader.hide();
        }
        $button.prop('disabled', false);
    });
});

function openWidget(flowID=false, views=false, shortname=false, ref=false) {
    // build arguments object for opening fareharbor widget
    let args = {};

    args.fallback = 'simple';
    args.fullItems = 'yes';
    args.language = lang;
    
    // add flow if declared
    if (flowID) {
        args.flow = flowID;
    }

    // add views if declared
    if (views) {
        views = { "item" : views}; 
        args.view = views; 
    }

    // set custom company/account name if declared
    if (typeof shortname !== 'undefined' && shortname) {
        args.shortname = shortname;
    }

    // set custom ref if declared
    if (typeof ref !== 'undefined' && ref) {
        args.ref = ref;
    }

    // open widget with args
    FH.open(args); 
}
